<template>
  <el-card class="box-card">
    <!-- <div class="center"> -->

    <!-- /* ---------------------------------- 返回按钮 ---------------------------------- */ -->
    <el-row v-show="isBack" type="flex" justify="space-between">
      <div class="btns-left">
        <el-button type="primary" @click="$router.back(-1)">{{
          $t('merchantdetails.backpage')
        }}</el-button>
      </div>

      <div class="btns-right">
        <!-- transfer:walletTransfer -->
        <el-button
          @click="action(2)"
          v-if="
            clientdata.merchantResources === 0 &&
            permission.indexOf('rechargeDeduction:merchantdetails') > -1
          "
        >
          {{ $t('btns.recharge') }}
        </el-button>
        <el-button v-if="false" @click="action(3)">
          {{ $t('btns.withdraw') }}
        </el-button>
      </div>
    </el-row>

    <el-row type="flex" justify="space-between" class="table">
      <el-col :span="24">
        <el-row>
          <div class="basic">
            <h2>{{ $t('merchantdetails.basic') }}</h2>
            <table cellspacing="0" cellpadding="15">
              <thead>
                <tr>
                  <th>{{ $t('clientmanage.table.merchantName') }}</th>
                  <th>{{ $t('clientmanage.table.merchantNo') }}</th>
                  <th>{{ $t('clientmanage.table.merchantEmail') }}</th>
                  <th>{{ $t('clientmanage.table.merchantPhone') }}</th>
                  <th>{{ $t('clientmanage.table.merchantStatus') }}</th>
                  <th>{{ $t('clientmanage.table.merchantModel') }}</th>
                  <!-- <th>{{ $t('merchantdetails.agency') }}：</th>
                  <th>{{ $t('clientmanage.table.merchantType') }}</th>
                  <th>{{ $t('clientmanage.table.merchantResources') }}</th>
                  <th>{{ $t('merchantdetails.merchantkey') }}</th> -->
                  <th>{{ $t('clientmanage.table.MerchantBalance') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ clientdata.merchantName }}</td>

                  <td>{{ clientdata.merchantNo }}</td>
                  <td>{{ clientdata.email }}</td>
                  <td>{{ clientdata.phone }}</td>

                  <td>
                    <template>
                      <div v-if="clientdata.merchantStatus == 0">
                        {{ $t('accountmanager.active') }}
                      </div>
                      <div v-if="clientdata.merchantStatus == 1">
                        {{ $t('accountmanager.inactive') }}
                      </div>
                    </template>
                  </td>
                  <td>
                    <template>
                      <div v-if="clientdata.merchantModel == 1">
                        {{ $t('clientmanage.addDialog.optionModtext1') }}
                      </div>
                      <div v-if="clientdata.merchantModel == 2">
                        {{ $t('clientmanage.addDialog.optionModtext2') }}
                      </div>
                    </template>
                  </td>
                  <!-- <td>{{ clientdata.agentAcct }}</td> -->
                  <!-- <td>
                    <template>
                      <div v-if="clientdata.merchantType == 0">
                        {{ $t('clientmanage.addDialog.optionTypetext1') }}
                      </div>
                      <div v-if="clientdata.merchantType == 1">
                        {{ $t('clientmanage.addDialog.optionTypetext2') }}
                      </div>
                      <div v-if="clientdata.merchantType == 2">
                        {{ $t('clientmanage.addDialog.optionTypetext3') }}
                      </div>
                    </template>
                  </td> -->

                  <!-- <td>
                    <template>
                      <div v-if="clientdata.merchantResources == 0">
                        {{ $t('clientmanage.addDialog.optionRestext1') }}
                      </div>
                      <div v-if="clientdata.merchantResources == 1">
                        {{ $t('clientmanage.addDialog.optionRestext2') }}
                      </div>
                    </template>
                  </td> -->
                  <!-- <td>{{ clientdata.merchantKey }}</td> -->

                  <td>{{ amountData.walletAmountTotal | toAmountotal }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </el-row>
        <el-row>
          <div class="detailed">
            <h2>{{ $t('merchantdetails.indetails') }}</h2>
            <table cellspacing="0" cellpadding="15">
              <thead>
                <tr>
                  <template v-for="(row, index) in indetails">
                    <th :key="index">{{ $t(`clientmanage.updataDia.${row.label}`) }}</th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <template v-for="row in indetails">
                    <td :key="row.label">
                      <span>{{ clientdata[row.value] }}</span>
                      <span v-if="row.value !== 'merchantWithdrawalFee' && row.value !== 'payoutFixedFee'">%</span>
                      <!--                      <span v-if="['onlineBankingDirectConnect', 'merchantWithdrawalFee'].indexOf(row.label) === -1">(未启用)</span>-->
                    </td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
        </el-row>

        <el-row v-show="isBack">
          <div class="detailed">
            <h2>{{ $t('merchantdetails.label.walletTile') }}</h2>
            <table cellspacing="0" cellpadding="15">
              <thead>
                <tr>
                  <template v-for="(val, key) in walletTypes">
                    <th :key="key">{{ $t(`merchantdetails.label.${key}`) }}</th>
                  </template>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <template v-for="(val, key) in walletTypes">
                    <td :key="key">{{ val }}</td>
                  </template>
                </tr>
              </tbody>
            </table>
          </div>
        </el-row>
      </el-col>
    </el-row>

    <!-- /* --------------------------------- 钱包转账弹窗 --------------------------------- */ -->
    <el-dialog
      :title="$t('btns.transfer')"
      :visible.sync="dialogVisible1"
      :close-on-click-modal="false"
      width="30%"
      append-to-body
    >
      <el-form :model="form1" :rules="form1Rules" ref="form1">
        <el-form-item prop="amount" :label="$t('merchantdetails.label.amount')">
          <el-input v-model.trim="form1.amount" />
        </el-form-item>
        <el-form-item
          prop="merchatNo"
          v-if="form1.merchatNo"
          :label="$t('merchantdetails.label.merchatNo')"
        >
          <el-input v-model.trim="form1.merchatNo" :disabled="true" />
        </el-form-item>
        <el-form-item
          prop="walletTypeTransferIn"
          :label="$t('merchantdetails.label.walletTypeTransferIn')"
        >
          <el-input v-model.trim="form1.walletTypeTransferIn" :disabled="true" />
        </el-form-item>
        <el-form-item
          prop="walletTypeTransferOut"
          :label="$t('merchantdetails.label.walletTypeTransferOut')"
        >
          <ul class="list-out">
            <li v-for="(item, key) in walletTypes" :key="key">
              <el-tag>
                <span>{{ key }}</span>
                <span>{{ item }}</span>
              </el-tag>
              <el-button @click="doWalletTransfer(key)">
                {{ $t('btns.confirm') }}
              </el-button>
            </li>
          </ul>
        </el-form-item>
      </el-form>
      <el-row slot="footer">
        <el-button @click="dialogVisible1 = false">
          {{ $t('btns.cancel') }}
        </el-button>
      </el-row>
    </el-dialog>

    <!-- /* ---------------------------------- 充值弹窗 ---------------------------------- */ -->
    <el-dialog
      :title="$t('btns.recharge')"
      :visible.sync="dialogVisible2"
      :close-on-click-modal="false"
      width="30%"
      append-to-body
    >
      <el-form :model="form2" :rules="form2Rules" ref="form2">
        <el-form-item prop="amount" :label="$t('merchantdetails.label.amount')">
          <el-input v-model.trim="form2.amount" />
        </el-form-item>
        <el-form-item prop="merchatNo" :label="$t('merchantdetails.label.merchatNo')">
          <el-input v-model.trim="form2.merchatNo" />
        </el-form-item>
      </el-form>
      <el-row slot="footer">
        <el-button @click="dialogVisible1 = false">
          {{ $t('btns.cancel') }}
        </el-button>
        <el-button @click="doRechargeDeduction">
          {{ $t('btns.confirm') }}
        </el-button>
      </el-row>
    </el-dialog>
  </el-card>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { isNumber } from '@/utils/validate';
import merchantdetailsApi from '@/api/merchantdetails';
export default {
  props: {
    isBack: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    isBack: {
      async handler(val) {
        if (val) {
          this.getAmount();
        }
      },
      immediate: true
    }
  },
  // @NOTE 不启用缓存
  // name: 'merchantdetails',
  data() {
    return {
      code: null, //验证码
      showinput: true,
      showbutton: true,
      amountData: {},

      form1: {},
      form2: {},
      dialogVisible1: false,
      dialogVisible2: false
    };
  },

  computed: {
    ...mapState({
      info({ user }) {
        return user.info;
      }
    }),
    ...mapGetters(['clientdata', 'permission']),
    walletTypes() {
      return Object.keys(this.amountData).reduce((acc, curr) => {
        if (curr === 'all' || curr === 'walletAmountTotal') {
          return acc;
        }
        acc[curr] = this.amountData[curr];
        return acc;
      }, {});
    },
    blance() {
      return this.amountData[this.form1.walletTypeTransferOut];
    }
  },
  created() {
     this.getAmount();
    this.handleEmpty1();
    this.handleEmpty2();

    this.indetails = [
      // {
      //   label: 'merchantWithdrawalType',
      //   value: 'merchantWithdrawalType'
      // },

      {
        label: 'card',
        value: 'card'
      },

      {
        label: 'momo',
        value: 'momo'
      },

      // {
      //   label: 'momoIpay',
      //   value: 'momoIpay'
      // },
      // {
      //   label: 'onlineBankingDirectConnect',
      //   value: 'onlineBankingDirectConnect'
      // },
      {
        label: 'onlineBankingQr',
        value: 'bank'
      },

      {
        label: 'payOnBehalfOf',
        value: 'payout'
      },
      {
        label: 'payoutFixedFee',
        value: 'payoutFixedFee'
      },
      {
        label: 'viettelpay',
        value: 'viettelpay'
      },
      {
        label: 'zalo',
        value: 'zalo'
      },
      {
        label: 'universal',
        value: 'universal'
      },
      {
        label: 'bankTransfer',
        value: 'bankTransfer'
      },
       {
        label: 'usdt',
        value: 'usdt'
      },
      {
        label: 'momoBank',
        value: 'momoBank'
      },
      {
        label: 'momoBank',
        value: 'momoBank'
      },
      {
        label: 'zaloBank',
        value: 'zaloBank'
      },
      {
        label: 'vtpBank',
        value: 'vtpayBank'
      },
      // {
      //   label: 'merchantWithdrawalFee',
      //   value: 'merchantWithdrawalFee'
      // }
    ];
    this.form1Rules = {
      amount: [
        {
          required: true,
          message: this.$t('merchantdetails.rules.amount.required'),
          trigger: 'blur'
        },
        {
          validator: (rules, value, cb) => {
            if (!isNumber(value)) {
              cb(new Error(this.$t('merchantdetails.rules.amount.type')));
            } else if (value > this.blance) {
              cb(new Error(this.$t('merchantdetails.rules.amount.max')));
            } else {
              cb();
            }
          }
        }
      ]
    };
    this.form2Rules = {
      amount: [
        {
          required: true,
          message: this.$t('merchantdetails.rules.amount.required'),
          trigger: 'blur'
        }
        // {
        //   validator: (rules, value, cb) => {
        //     if (!isNumber(value)) {
        //       cb(new Error(this.$t('merchantdetails.rules.amount.type')));
        //     } else if (value > this.blance) {
        //       cb(new Error(this.$t('merchantdetails.rules.amount.max')));
        //     } else {
        //       cb();
        //     }
        //   }
        // }
      ],
      merchatNo: [
        {
          required: true,
          message: this.$t('transaction.rules.merchantNo'),
          trigger: 'blur'
        }
      ]
    };
  },
  mounted() {
    // this.getAmount();
  },
  methods: {
    handleEmpty1() {
      this.form1 = {
        amount: '',
        // merchatNo: this.clientdata.merchantNo,
        walletTypeTransferIn: 'all',
        walletTypeTransferOut: ''
      };
    },
    handleEmpty2() {
      this.form2 = { amount: '', merchatNo: this.clientdata.merchantNo };
    },
    action(key) {
      if (key === 1) {
        this.dialogVisible1 = true;
      }
      if (key === 2) {
        this.dialogVisible2 = true;
      }
      if (key === 3) {
        // this.$router.push({ name: 'merchantdeposit' });
      }
    },
    async getAmount() {
      const params = {
        merchantNo: this.clientdata.merchantNo
      };
      const { data } = await merchantdetailsApi.getAmount(params);
      if (data && data.code === 200) {
        this.amountData = data.data || {};
        /**
         * "zalo": 10.0,
         * "bank": 10.0,
         * "viettelpay": 10.0,
         * "momo": 10.0,
         * "card": 10.0,
         * "walletAmountTotal": 50.0
         */
      } else {
        this.$message.error(data.msg);
      }
    },
    async doWalletTransfer(key) {
      this.form1.walletTypeTransferOut = key;
      this.$refs.form1.validate(async (valid) => {
        if (valid) {
          const { data } = await merchantdetailsApi.doWalletTransfer(this.form1);
          if (data) {
            if (data.code === 200) {
              this.getAmount();
            } else {
              this.$message.error(data.msg);
            }
          }
        }
      });
    },
    async doRechargeDeduction() {
      const { data } = await merchantdetailsApi.doRechargeDeduction(this.form2);
      if (data) {
        if (data.code === 200) {
          this.getAmount();
          this.dialogVisible2 = false;
          this.handleEmpty2();
        } else {
          this.$message.error(data.msg);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.basic,
.detailed,
.QRcode {
  float: left;
  margin-top: 2%;
  margin-left: 5.5%;
  margin-bottom: 20px;
}
tr,
th,
td,
table {
  border: 1px solid #999999;
}
tr {
  text-align: left;
}

td {
  min-width: 150px;
  text-align: center;
}

.list-out {
  list-style: none;
  padding-top: 30px;

  /deep/ .el-tag {
    min-width: 120px;
  }
}

/* ------------------------------ 覆盖element-ui ------------------------------ */
/deep/ .el-row {
  &.table {
    .el-col-24 {
      border: 1px solid #000;
      overflow-x: scroll;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/clientmanage/merchantdetails.vue